import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";

import { createApproval } from "../report-header/reportHeaderSlice";

import { useParams, useHistory } from "react-router-dom";
import {
  toAbsoluteUrl,
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import {
  createChanges,
  fetchUsername,
  resetData,
  fetchChanges,
  selectDataChanges,
  selectLoading,
  selectData,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
} from "./approvalSlice";
import LoadingFetchData from "../../../utility/LoadingFetchData";
import {
  sizePerPageList,
  showErrorDialog,
  showSuccessDialog,
  formatDate,
} from "../../../utility";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  fetchAll,
  selectData as dataUser,
  selectPageNo as pageNoUser,
  selectPageSize as pageSizeUser,
  selectTotalRecord as totalRecordUser,
} from "../../administrator/master-user/userSlice";

export const ApprovalChangePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const dataUsers = useSelector(dataUser);
  const dataChanges = useSelector(selectDataChanges);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageNoUsers = useSelector(pageNoUser);
  const pageSize = useSelector(selectPageSize);
  const pageSizeUsers = useSelector(pageSizeUser);
  const totalRecord = useSelector(selectTotalRecord);
  const totalRecordUsers = useSelector(totalRecordUser);
  const { SearchBar } = Search;

  // Filter
  const [username, setUsername] = useState("");
  const [usernameOld, setUsernameOld] = useState("");
  const [usernameNew, setUsernameNew] = useState("");
  const [approvalOld, setApprovalOld] = useState(null);
  const [approvalNew, setApprovalNew] = useState(null);
  const [overlay, setOverlay] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [onSelectAll, setOnSelectAll] = useState(false);
  const [muncul, setMuncul] = useState(false);
  const [tableData, setTableData] = useState("");
  const [tableDataChanges, setTableDataChanges] = useState([]);
  const [tableDataUsername, setTableDataUsername] = useState([]);

  console.log(usernameOld, "usernameOld");

  const { id } = useParams();

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    // Add number
    const initData =
      dataChanges === null
        ? []
        : dataChanges.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
    setTableDataChanges(initData);
  }, [dataChanges, pageSize, pageNo]);

  const handleSearch = async () => {
    if (usernameOld === "") {
      return showErrorDialog("please input username old ");
    }
    const params = {
      username: usernameOld.userName,
      pageNo: 1,
      pageSize: 0,
    };
    try {
      const response = await dispatch(fetchChanges(params));
      console.log(response);
      if (response.payload.data.status === 200) {
        // setOverlay(false)
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const params = {
      username: usernameOld.userName,
      pageNo: page,
      pageSize: sizePerPage,
    };
    try {
      const response = await dispatch(fetchChanges(params));
      console.log(response);
      if (response.payload.data.status === 200) {
        // setOverlay(false)
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // search username
  const [showNew, setShowNew] = useState(false);

  const handleCloseNew = () => {
    setTableDataUsername([]);
    setShowNew(false);
  };
  const handleShowNew = () => {
    if (usernameOld === "") {
      return showErrorDialog("Please select username old first");
    }
    setShowNew(true);
  };

  useEffect(() => {
    // Add number
    const pageBefore = pageSizeUsers * (pageNoUsers - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        listRole: item.roles.map((e) => {
          return e.roleName;
        }),
        listPlant: item.plants.map((e) => {
          return e.plantCode;
        }),
      };
    });
    setTableDataUsername(initData);
  }, [data, pageSize, pageNo]);

  const handleSearchUsername = async () => {
    const listRole = usernameOld.roles.map((e) => {
      return e.roleName;
    });

    const listPlant = usernameOld.plants.map((e) => {
      return e.plantCode;
    });

    const params = {
      username: username,
      role: listRole.toString(),
      // plant: listPlant.toString(),
      pageNo: 1,
      pageSize: 10,
    };
    console.log(params, "params");
    try {
      const response = await dispatch(fetchUsername(params));
      console.log(response);
      if (response.payload.data.status === 200) {
        // setOverlay(false)
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChangeUsername = async (type, { page, sizePerPage }) => {
    const params = {
      username: usernameOld.userName,
      pageNo: page,
      pageSize: sizePerPage,
    };
    try {
      const response = await dispatch(fetchChanges(params));
      console.log(response);
      if (response.payload.data.status === 200) {
        // setOverlay(false)
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  let rowEventsUsername = {
    onClick: (e, row, rowIndex, cell) => {
      setUsernameNew(row);
      handleCloseNew();
    },
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const [show, setShow] = useState(false);
  const [clientCode, setClientCode] = useState("");
  const [clientName, setClientName] = useState("");
  const [selectedClient, setSelectedClient] = useState([]);

  const handleClose = () => {
    setClientCode("");
    setClientName("");
    setShow(false);
    setTableData([]);
    setShow(false);
  };
  const handleShow = () => setShow(true);

  useEffect(() => {
    // Add number
    const pageBefore = pageSizeUsers * (pageNoUsers - 1);
    const initData = dataUsers.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        listRole: item.roles.map((e) => {
          return e.roleName;
        }),
        listPlant: item.plants.map((e) => {
          return e.plantCode;
        }),
      };
    });
    console.log(initData, "a");
    setTableData(initData);
  }, [dataUsers, pageSizeUsers, pageNoUsers]);

  const handleSearchUser = async () => {
    const params = {
      userName: username,
      pageNo: 1,
      pageSize: 10,
    };
    setOverlay(true);
    try {
      const response = await dispatch(fetchAll(params));
      console.log(response);
      if (response.payload.data.status === 200) {
        setOverlay(false);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChangeUser = async (type, { page, sizePerPage }) => {
    const params = {
      userName: username,
      pageNo: page,
      pageSize: sizePerPage,
    };
    await setOverlay(true);
    await dispatch(fetchAll(params));
    await setOverlay(false);
  };

  const options = {
    page: pageNoUsers,
    sizePerPage: pageSizeUsers,
    showTotal: true,
    totalSize: totalRecordUsers,
    sizePerPageList: sizePerPageList,
  };

  const optionsUsername = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const columnsUser = [
    { text: "no", dataField: "no" },
    { text: "username", dataField: "userName" },
    { text: "roles", dataField: "listRole" },
    { text: "plants", dataField: "listPlant" },
  ];

  let rowEvents = {
    onClick: (e, row, rowIndex, cell) => {
      setUsernameOld(row);
      handleClose();
    },
  };

  const tableDataRetnumber = [
    {
      no: 1,
      retNumber: "191022090012",
    },
    {
      no: 2,
      retNumber: "191022090013",
    },
    {
      no: 3,
      retNumber: "191022090014",
    },
    {
      no: 5,
      retNumber: "191022090016",
    },
    {
      no: 6,
      retNumber: "191022090017",
    },
    {
      no: 8,
      retNumber: "191022090019",
    },
    {
      no: 9,
      retNumber: "191022090020",
    },
  ];

  const columnsRetnumber = [
    { text: "no", dataField: "no" },
    { text: "retNumber", dataField: "retNumber" },
    { text: "created Date", dataField: "createdDate", formatter: formatDate },
  ];

  const onSelectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelectAll: (isSelect) => {
      if (isSelect) {
        setSelectedRows(dataChanges);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  console.log(selectedRows, "selectedRows");

  const handleSave = async () => {
    if (selectedRows.length < 1) {
      return showErrorDialog("Please select RetNumber");
    }
    if (usernameNew === "") {
      return showErrorDialog("Please input username new");
    }
    const params = {
      usernameOld: usernameOld.userName,
      usernameNew: usernameNew.userName,
      retNumber: selectedRows.map((e) => {
        return e.retNumber;
      }),
    };

    console.log(params, "params");

    try {
      const response = await dispatch(createChanges(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="Approval Changes"></CardHeader>
        <CardBody>
          {/* Filter */}
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Username Old</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    value={usernameOld.userName}
                    disabled
                  />
                </Col>
                <Col sm={1}>
                  <div
                    className="btn btn-icon btn-light btn-hover-secondary btn-sm"
                    onClick={handleShow}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Search.svg"
                        )}
                      />
                    </span>
                  </div>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Role</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    value={usernameOld.listRole}
                    disabled
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Plants</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    value={usernameOld.listPlant}
                    disabled
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Username New</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    value={usernameNew.userName}
                    disabled
                  />
                </Col>

                <Col sm={1}>
                  <div
                    className="btn btn-icon btn-light btn-hover-secondary btn-sm"
                    onClick={handleShowNew}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Search.svg"
                        )}
                      />
                    </span>
                  </div>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Role</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control type="text" value={usernameNew.listRole} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Plant</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control type="text" value={usernameNew.listPlant} />
                </Col>
              </Form.Group>
            </Col>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Button className="btn btn-primary" onClick={handleSearch}>
                  Search
                </Button>
              </Col>
            </Form.Group>
          </Form.Group>

          {tableDataChanges.length > 0 && (
            <>
              <div
                className="card-body pt-0"
                style={{
                  height: "350px",
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableDataChanges}
                  columns={columnsRetnumber}
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <h3> List Return</h3>
                        </Col>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>

                      <hr />
                      <BootstrapTable
                        // wrapperClasses="table-responsive"
                        classes="table table-head-custom table-vertical-center"
                        bootstrap4
                        bordered={false}
                        selectRow={onSelectRow}
                        {...props.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </>
          )}

          {tableDataChanges.length > 0 && (
            <Row className="mx-5 mt-5">
              <Button variant="success" className="mx-5" onClick={handleSave}>
                Save
              </Button>
            </Row>
          )}
        </CardBody>
      </Card>
      {/* old */}
      <Modal show={show} onHide={handleClose} size="lg">
        <LoadingFetchData active={overlay} />
        <Modal.Header closeButton>
          <Modal.Title>User Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Username</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    onChange={(e) => {
                      setUsername(e.target.value);
                    }}
                    value={username}
                    required
                    type="text"
                  />
                </Col>
              </Form.Group>
            </Col>
            {/* Right Row */}
            <Col sm={6}></Col>
          </Form.Group>

          <Button
            className="mb-5"
            variant="secondary"
            onClick={handleSearchUser}
          >
            Search
          </Button>
          {tableData.length > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              keyField="id"
              data={tableData}
              columns={columnsUser}
              pagination={paginationFactory(options)}
              onTableChange={handleTableChangeUser}
              rowEvents={rowEvents}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Row className="mt-6">
            <Button
              variant="light"
              className="mr-3"
              onClick={() => handleClose()}
            >
              <i className="fa fa-arrow-left"></i>Cancel
            </Button>
          </Row>
        </Modal.Footer>
      </Modal>
      {/* new */}
      <Modal show={showNew} onHide={handleCloseNew} size="lg">
        <LoadingFetchData active={overlay} />
        <Modal.Header closeButton>
          <Modal.Title>User Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Username</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    onChange={(e) => {
                      setUsername(e.target.value);
                    }}
                    value={username}
                    required
                    type="text"
                  />
                </Col>
              </Form.Group>
            </Col>
            {/* Right Row */}
            <Col sm={6}></Col>
          </Form.Group>

          <Button
            className="mb-5"
            variant="secondary"
            onClick={handleSearchUsername}
          >
            Search
          </Button>
          {tableDataUsername.length > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              keyField="id"
              data={tableDataUsername}
              columns={columnsUser}
              pagination={paginationFactory(optionsUsername)}
              onTableChange={handleTableChangeUsername}
              rowEvents={rowEventsUsername}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Row className="mt-6">
            <Button
              variant="light"
              className="mr-3"
              onClick={() => handleClose()}
            >
              <i className="fa fa-arrow-left"></i>Cancel
            </Button>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};
